<template>
  <div>
    <m-textArea class="data-list" ref="dataList">
      <VideoList
        :datalist="datalist"
        category="pianhua"
        @play="$emit('playVideo', $event)"
      ></VideoList>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </m-textArea>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import TextArea from "@/components/TextArea";
import VideoList from './VideoList';
import Pagination from "@/components/Pagination";

export default {
  components: {
    "m-textArea": TextArea,
    Pagination,
    VideoList
  },
  computed: {
    ...mapState(["extension"]),
    datalist() {
      return this.extension[this.pageNow]
    },
    pageNow() {
      return this.extension.number
    },
    pages() {
      return this.extension.total_pages;
    }
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getExtension"]),
    getPageData(page_num = 0) {
      const param = {
        category: "影视片花",
        page_num
      };
      this.getExtension(param);
    },
    chagenPage(num) {
      this.getPageData(num);
      this.$refs.dataList.scroll();
    }
  }
}
</script>